import "./Dashboard.02d5a840.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ix7R1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d7e166c0368815cd$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $klH19 = parcelRequire("klH19");

var $iS8eH = parcelRequire("iS8eH");

var $h8sKa = parcelRequire("h8sKa");

var $6lxfX = parcelRequire("6lxfX");

var $jBHLG = parcelRequire("jBHLG");

var $3CfG2 = parcelRequire("3CfG2");
var $d7e166c0368815cd$export$2e2bcd8739ae039 = {
    __name: 'Login',
    setup (__props, { expose: __expose }) {
        __expose();
        const $t = (0, $iS8eH.default).global.t;
        const email = (0, $ecd4d.ref)('');
        const password = (0, $ecd4d.ref)('');
        const confirmPassword = (0, $ecd4d.ref)('');
        const authCode = (0, $ecd4d.ref)('');
        const mailAuthCode = (0, $ecd4d.ref)('');
        const mode = (0, $ecd4d.ref)(location.search.includes('signup=true') ? 'register' : 'login');
        const isMailAuth = (0, $ecd4d.ref)(false);
        const timerCount = (0, $ecd4d.ref)(60);
        const timerId = (0, $ecd4d.ref)(null);
        const loading = (0, $ecd4d.ref)(false);
        const agreeRules = (0, $ecd4d.ref)(false);
        const timerFinished = (0, $ecd4d.computed)(()=>timerCount.value <= 0);
        const showMailAuthTip = (0, $ecd4d.ref)(false);
        const sendCodeLoading = (0, $ecd4d.ref)(false);
        const forgotPasswordProcessing = (0, $ecd4d.ref)(false);
        const showResetPasswordBtn = (0, $ecd4d.ref)(false);
        const eyeIconEventHandlers = new Map();
        const toast = new (0, $6lxfX.default)();
        const isValidPassword = (pwd)=>/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9%_+\-.]{10,50}$/.test(pwd || '');
        const termsHtml = (0, $ecd4d.computed)(()=>{
            const termsText = $t('login.terms');
            return termsText.replace(/<link>(.*?)<\/link>/g, '<a target="_blank" href="../assets/files/rules.pdf">$1</a>');
        });
        const startTimer = ()=>{
            timerCount.value = 60;
            if (timerId.value) clearInterval(timerId.value);
            timerId.value = setInterval(()=>{
                timerCount.value -= 1;
                if (timerCount.value < 0) clearInterval(timerId.value);
            }, 1000);
        };
        const resendMailAuth = async ()=>{
            if (!email.value) return;
            const res = await (0, $h8sKa.request)('auth/login_mail_code', {
                email: email.value
            }, false);
            if (res?.code === 200) startTimer();
        };
        const startMailAuth = ()=>{
            isMailAuth.value = true;
            startTimer();
            new (0, $6lxfX.default)().toast('success', $t('login.verifiSent'));
            setTimeout(()=>{
                const mailAuthEl = document.getElementById('mailAuthCode');
                if (mailAuthEl) mailAuthEl.focus();
            }, 100);
        };
        const resetTokens = ()=>{
            localStorage.removeItem('SCANAT_TOKEN');
            localStorage.removeItem('SCANAT_REFRESH_TOKEN');
            sessionStorage.removeItem('SCANAT_USER_INFO');
            localStorage.removeItem((0, $3CfG2.STORAGE_KEY).LOGIN_TIME);
            sessionStorage.removeItem('customer');
        };
        const validateMailAuthCode = (value)=>{
            const isSixNumber = value.length === 6 && value.match(/^\d+$/);
            if ((0, $h8sKa.isMobile)()) showMailAuthTip.value = !isSixNumber;
            else showMailAuthTip.value = !isSixNumber && value.length > 0;
            return isSixNumber;
        };
        const handleLogin = async ()=>{
            if (!email.value || !password.value) {
                toast.toast('danger', $t('login.noEmpty'));
                return;
            }
            if (!(0, $h8sKa.isEmail)(email.value)) {
                toast.toast('danger', $t('login.emailError'));
                return;
            }
            if (isMailAuth.value && mailAuthCode.value) {
                if (!validateMailAuthCode(mailAuthCode.value)) {
                    toast.toast('danger', $t('login.verifyNumber'));
                    return;
                }
            }
            loading.value = true;
            resetTokens();
            let url = 'auth/login';
            const data = {
                email: email.value,
                password: password.value,
                isFromPortal: true
            };
            if (isMailAuth.value && mailAuthCode.value) {
                url = 'auth/mail_code_login';
                data.mailCode = mailAuthCode.value;
            }
            const res = await (0, $h8sKa.request)(url, data, false);
            loading.value = false;
            if (!res) return;
            if (res?.code === 20000) {
                startMailAuth();
                return;
            }
            if (res?.code === 200 && res?.data?.refresh_token) {
                const tokenRes = await (0, $h8sKa.request)('auth/refresh_token', {
                    refreshToken: res.data.refresh_token,
                    isFromPortal: true
                }, false);
                if (tokenRes.code === 200) {
                    localStorage.setItem('SCANAT_REFRESH_TOKEN', tokenRes.data.refresh_token);
                    localStorage.setItem('SCANAT_TOKEN', tokenRes.data.access_token);
                    localStorage.setItem((0, $3CfG2.STORAGE_KEY).LOGIN_TIME, new Date().getTime().toString());
                }
                const userRes = await (0, $h8sKa.request)('auth/currentUserInfo', null, true, 'POST', false);
                if (userRes?.code === 200) {
                    const userInfo = userRes.data || {};
                    if ([
                        0,
                        6
                    ].includes(userInfo.userStatus)) {
                        localStorage.removeItem('SCANAT_TOKEN');
                        localStorage.removeItem('SCANAT_REFRESH_TOKEN');
                        toast.toast('warning', $t('error.accountNoAccess'));
                        return;
                    }
                }
                toast.toast('success', $t('login.loginSuccess'), false, {
                    callback: ()=>{
                        const modelKey = sessionStorage.getItem('SCANAT_SHARE_KEY');
                        const redirectUrl = sessionStorage.getItem('SCANAT_SHARE_LINK');
                        if (redirectUrl) {
                            window.location.href = redirectUrl;
                            sessionStorage.removeItem('SCANAT_SHARE_LINK');
                        } else if (modelKey) {
                            sessionStorage.removeItem('SCANAT_SHARE_KEY');
                            window.location.href = `./models.html?${modelKey}`;
                        } else window.location.href = './landing.html';
                    }
                });
            }
        };
        const handleSendRegisterCode = async ()=>{
            if (!email.value) {
                toast.toast('danger', $t('login.noEmpty'));
                return;
            }
            if (sendCodeLoading.value) return;
            sendCodeLoading.value = true;
            try {
                const codeRes = await (0, $h8sKa.request)('auth/register_code', {
                    email: email.value
                }, false);
                if (codeRes.code === 200) toast.toast('success', $t('login.sent'), false, {
                    callback: ()=>{
                        sendCodeLoading.value = false;
                    }
                });
                else toast.toast('danger', codeRes.message, false, {
                    callback: ()=>{
                        sendCodeLoading.value = false;
                    }
                });
            } catch (e) {
                toast.toast('danger', e.message, false, {
                    callback: ()=>{
                        sendCodeLoading.value = false;
                    }
                });
            }
        };
        const handleRegister = async ()=>{
            if (!email.value || !password.value || !confirmPassword.value || !authCode.value) {
                toast.toast('danger', $t('login.noEmpty'));
                return;
            }
            if (!isValidPassword(password.value) || !isValidPassword(confirmPassword.value)) {
                toast.toast('danger', $t('login.passwordTip'));
                return;
            }
            if (!(0, $h8sKa.isEmail)(email.value)) {
                toast.toast('danger', $t('login.emailError'));
                return;
            }
            if (!validateMailAuthCode(authCode.value)) {
                toast.toast('danger', $t('login.verifyNumber'));
                return;
            }
            if (!agreeRules.value) {
                toast.toast('warning', $t('login.termsError'));
                return;
            }
            loading.value = true;
            const res = await (0, $h8sKa.request)('auth/portal_register', {
                email: email.value,
                password: password.value,
                confirmPassword: confirmPassword.value,
                authCode: authCode.value
            }, false);
            console.log(res, 'res');
            loading.value = false;
            if (res?.code === 200) {
                sessionStorage.removeItem('SCANAT_SHARE_LINK');
                toast.toast('success', $t('login.registerSuccess'), false, {
                    callback: ()=>window.location.reload()
                });
            }
        };
        const handleResetPassword = async ()=>{
            const res = await (0, $h8sKa.request)('auth/reset_password', {
                email: email.value,
                password: password.value,
                confirmPassword: confirmPassword.value,
                authCode: authCode.value
            }, false);
            if (res?.code === 200) toast.toast('success', $t('login.resetPasswordSuccess'), false, {
                callback: ()=>{
                    window.location.href = '/login.html';
                }
            });
            else if (res.code === 807) {
                const messageModalEl = document.getElementById('messageModal');
                if (messageModalEl) {
                    const titleEl = messageModalEl.querySelector('.title');
                    if (titleEl) titleEl.textContent = res.message;
                    new mdb.Modal(messageModalEl).show();
                }
            }
        };
        const handleForgotPassword = async ()=>{
            if (!email.value) {
                toast.toast('danger', $t('login.noEmpty'));
                return;
            }
            if (forgotPasswordProcessing.value) return;
            forgotPasswordProcessing.value = true;
            try {
                const res = await (0, $h8sKa.request)('auth/sendResetPasswordEmail', {
                    email: email.value
                }, false);
                if (res?.code === 200) {
                    const resetInfoModalEl = document.getElementById('resetInfoModal');
                    if (resetInfoModalEl) new mdb.Modal(resetInfoModalEl).show();
                } else if (res?.code === 501) toast.toast('danger', $t('login.forgetPasswordToast'));
                else if (res?.code === 405) toast.toast('danger', $t('login.emailNone'));
            } finally{
                setTimeout(()=>{
                    forgotPasswordProcessing.value = false;
                }, 300);
            }
        };
        const toggleMode = ()=>{
            mode.value = mode.value === 'register' ? 'login' : 'register';
            isMailAuth.value = false;
            mailAuthCode.value = '';
            showResetPasswordBtn.value = false;
            (0, $ecd4d.nextTick)(()=>{
                setupPasswordEyeIcon();
            });
        };
        const setupPasswordEyeIcon = ()=>{
            const passwordEl = document.getElementById('password');
            const confirmPasswordEl = document.getElementById('confirmed-password');
            const eyeIcons = document.querySelectorAll('.eye-icon');
            eyeIcons.forEach((eyeIcon, index)=>{
                if (eyeIconEventHandlers.has(eyeIcon)) {
                    const handlers = eyeIconEventHandlers.get(eyeIcon);
                    eyeIcon.removeEventListener('mouseover', handlers.mouseover);
                    eyeIcon.removeEventListener('mouseout', handlers.mouseout);
                    eyeIconEventHandlers.delete(eyeIcon);
                }
                const targetInput = index === 0 ? passwordEl : confirmPasswordEl;
                if (!targetInput) return;
                const mouseoverHandler = ()=>{
                    if (targetInput.type === 'password') targetInput.type = 'text';
                };
                const mouseoutHandler = ()=>{
                    if (targetInput.type === 'text') targetInput.type = 'password';
                };
                eyeIcon.addEventListener('mouseover', mouseoverHandler);
                eyeIcon.addEventListener('mouseout', mouseoutHandler);
                eyeIconEventHandlers.set(eyeIcon, {
                    mouseover: mouseoverHandler,
                    mouseout: mouseoutHandler
                });
            });
        };
        const goHome = ()=>{
            sessionStorage.removeItem('SCANAT_SHARE_LINK');
            window.location.href = '/';
        };
        (0, $ecd4d.watch)(mode, ()=>{
            (0, $ecd4d.nextTick)(()=>{
                setupPasswordEyeIcon();
            });
        });
        (0, $ecd4d.watchEffect)(()=>{
            document.title = `${mode.value === 'register' ? $t('login.register') : $t('login.login')} Scanat`;
        });
        (0, $ecd4d.onMounted)(()=>{
            const removeShareBtn = document.querySelectorAll('.remove-share');
            removeShareBtn.forEach((btn)=>{
                btn?.addEventListener('click', ()=>{
                    sessionStorage.removeItem('SCANAT_SHARE_LINK');
                });
            });
            (0, $ecd4d.nextTick)(()=>{
                setupPasswordEyeIcon();
            });
        });
        const onMailAuthCodeInput = (e)=>{
            const value = e.target?.value || '';
            validateMailAuthCode(value);
        };
        const __returned__ = {
            $t: $t,
            email: email,
            password: password,
            confirmPassword: confirmPassword,
            authCode: authCode,
            mailAuthCode: mailAuthCode,
            mode: mode,
            isMailAuth: isMailAuth,
            timerCount: timerCount,
            timerId: timerId,
            loading: loading,
            agreeRules: agreeRules,
            timerFinished: timerFinished,
            showMailAuthTip: showMailAuthTip,
            sendCodeLoading: sendCodeLoading,
            forgotPasswordProcessing: forgotPasswordProcessing,
            showResetPasswordBtn: showResetPasswordBtn,
            eyeIconEventHandlers: eyeIconEventHandlers,
            toast: toast,
            isValidPassword: isValidPassword,
            termsHtml: termsHtml,
            startTimer: startTimer,
            resendMailAuth: resendMailAuth,
            startMailAuth: startMailAuth,
            resetTokens: resetTokens,
            validateMailAuthCode: validateMailAuthCode,
            handleLogin: handleLogin,
            handleSendRegisterCode: handleSendRegisterCode,
            handleRegister: handleRegister,
            handleResetPassword: handleResetPassword,
            handleForgotPassword: handleForgotPassword,
            toggleMode: toggleMode,
            setupPasswordEyeIcon: setupPasswordEyeIcon,
            goHome: goHome,
            onMailAuthCodeInput: onMailAuthCodeInput,
            computed: $ecd4d.computed,
            nextTick: $ecd4d.nextTick,
            onMounted: $ecd4d.onMounted,
            ref: $ecd4d.ref,
            watch: $ecd4d.watch,
            watchEffect: $ecd4d.watchEffect,
            LanguageSwitcher: $klH19.default,
            get i18n () {
                return 0, $iS8eH.default;
            },
            get isEmail () {
                return 0, $h8sKa.isEmail;
            },
            get isMobile () {
                return 0, $h8sKa.isMobile;
            },
            get request () {
                return 0, $h8sKa.request;
            },
            get Toast () {
                return 0, $6lxfX.default;
            },
            get iconNext () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($jBHLG));
            },
            get STORAGE_KEY () {
                return 0, $3CfG2.STORAGE_KEY;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("klH19", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed072337608a63ed$export$2e2bcd8739ae039);
let $ed072337608a63ed$var$script;



let $ed072337608a63ed$var$initialize = ()=>{
    $ed072337608a63ed$var$script = (parcelRequire("kjbTW"));
    if ($ed072337608a63ed$var$script.__esModule) $ed072337608a63ed$var$script = $ed072337608a63ed$var$script.default;
    $ed072337608a63ed$var$script.render = (parcelRequire("2m22M")).render;
    (parcelRequire("iPEmN")).default($ed072337608a63ed$var$script);
    $ed072337608a63ed$var$script.__scopeId = 'data-v-b9272f';
    $ed072337608a63ed$var$script.__file = "LanguageSwitcher.vue";
};
$ed072337608a63ed$var$initialize();
var $ed072337608a63ed$export$2e2bcd8739ae039 = $ed072337608a63ed$var$script;

});
parcelRegister("kjbTW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec8ed055191c1788$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $jFUWD = parcelRequire("jFUWD");

var $eZeDV = parcelRequire("eZeDV");
var $ec8ed055191c1788$export$2e2bcd8739ae039 = {
    __name: 'LanguageSwitcher',
    props: {
        isDarkMode: {
            type: Boolean,
            default: false
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const { locale: locale } = (0, $jFUWD.useI18n)();
        const currentLang = (0, $ecd4d.ref)('');
        const isHidden = (0, $ecd4d.ref)(true);
        const currentLabel = (0, $ecd4d.computed)(()=>{
            if (currentLang.value === 'ja') return "\u65E5\u672C\u8A9E";
            if (currentLang.value === 'en') return 'English';
            if (currentLang.value === 'zh') return "\u7B80\u4F53\u4E2D\u6587";
            return "\u65E5\u672C\u8A9E";
        });
        const switchLanguage = (lang)=>{
            currentLang.value = lang;
            locale.value = lang;
            localStorage.setItem('SCANAT_LANG', lang);
            (0, (/*@__PURE__*/$parcel$interopDefault($eZeDV))).set('language', lang);
            window.dispatchEvent(new CustomEvent('languageChanged', {
                detail: {
                    lang: lang
                }
            }));
            // 更新页面语言
            const iframeEl = document.querySelector('.model-body-container');
            iframeEl?.contentWindow?.postMessage({
                name: 'lang',
                lang: lang === 'zh' ? 'cn' : lang,
                type: 'modelData'
            }, '*');
        };
        const setPageLang = ()=>{
            const lang = localStorage.getItem('SCANAT_LANG') || (0, (/*@__PURE__*/$parcel$interopDefault($eZeDV))).get('language') || 'ja';
            currentLang.value = lang;
            locale.value = lang;
            isHidden.value = false;
        };
        (0, $ecd4d.onMounted)(()=>{
            setPageLang();
        });
        const __returned__ = {
            props: props,
            locale: locale,
            currentLang: currentLang,
            isHidden: isHidden,
            currentLabel: currentLabel,
            switchLanguage: switchLanguage,
            setPageLang: setPageLang,
            ref: $ecd4d.ref,
            computed: $ecd4d.computed,
            onMounted: $ecd4d.onMounted,
            get useI18n () {
                return 0, $jFUWD.useI18n;
            },
            get Cookies () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($eZeDV));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("2m22M", function(module, exports) {

$parcel$export(module.exports, "render", () => $1b6f38b1a8649826$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");

var $gHKAg = parcelRequire("gHKAg");

var $gKT0D = parcelRequire("gKT0D");
const $1b6f38b1a8649826$var$_hoisted_1 = {
    "data-mdb-toggle": "dropdown",
    "data-mdb-display": "static",
    "data-mdb-reference": "parent",
    "data-mdb-dropdown-animation": "off",
    class: "d-flex align-items-center gap-8"
};
const $1b6f38b1a8649826$var$_hoisted_2 = {
    class: "dropdown-menu dropdown-menu-end b-r-4 top-32",
    style: {
        "box-shadow": "0 10px 48px 0 #00365b33",
        "padding": "0.5rem 0"
    }
};
const $1b6f38b1a8649826$var$_hoisted_3 = {
    class: "d-flex flex-wrap"
};
function $1b6f38b1a8649826$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", {
        ref: "menuEl",
        class: (0, $ecd4d.normalizeClass)([
            "d-flex align-items-center gap-8 cursor-pointer dropdown-toggle after-none position-relative i18n-menu mr-20 px-20",
            {
                'd-none': $setup.isHidden
            }
        ]),
        style: (0, $ecd4d.normalizeStyle)({
            'border-right': $props.isDarkMode ? '1px solid #ffffff33' : '1px solid rgba(0, 54, 91, 0.2)'
        })
    }, [
        (0, $ecd4d.createElementVNode)("div", $1b6f38b1a8649826$var$_hoisted_1, [
            (0, $ecd4d.createElementVNode)("span", {
                ref: "labelEl",
                class: (0, $ecd4d.normalizeClass)([
                    "fs-14",
                    {
                        'text-white': $props.isDarkMode
                    }
                ])
            }, (0, $ecd4d.toDisplayString)($setup.currentLabel), 3),
            (0, $ecd4d.createElementVNode)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($gHKAg))),
                alt: "down",
                class: "icon-14 dropdown-icon",
                style: (0, $ecd4d.normalizeStyle)({
                    'filter': $props.isDarkMode ? 'brightness(0) invert(1)' : 'none'
                })
            }, null, 4)
        ]),
        (0, $ecd4d.createElementVNode)("ul", $1b6f38b1a8649826$var$_hoisted_2, [
            (0, $ecd4d.createElementVNode)("li", $1b6f38b1a8649826$var$_hoisted_3, [
                (0, $ecd4d.createElementVNode)("a", {
                    class: (0, $ecd4d.normalizeClass)([
                        "d-flex gap-16 align-items-center text-00365b entry",
                        {
                            'entry-active': $setup.currentLang === 'ja'
                        }
                    ]),
                    style: {
                        "padding": "0.5rem 1.5rem"
                    },
                    "data-lang": "ja",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$setup.switchLanguage('ja'))
                }, [
                    ..._cache[3] || (_cache[3] = [
                        (0, $ecd4d.createElementVNode)("div", {
                            class: "flex-grow-1",
                            style: {
                                "width": "5rem"
                            }
                        }, "\u65E5\u672C\u8A9E", -1),
                        (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($gKT0D))),
                            alt: "avatar",
                            class: "w-16 h-16 check-icon"
                        }, null, -1)
                    ])
                ], 2),
                (0, $ecd4d.createElementVNode)("a", {
                    class: (0, $ecd4d.normalizeClass)([
                        "d-flex gap-16 align-items-center text-00365b entry",
                        {
                            'entry-active': $setup.currentLang === 'en'
                        }
                    ]),
                    style: {
                        "padding": "0.5rem 1.5rem"
                    },
                    "data-lang": "en",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.switchLanguage('en'))
                }, [
                    ..._cache[4] || (_cache[4] = [
                        (0, $ecd4d.createElementVNode)("div", {
                            class: "flex-grow-1",
                            style: {
                                "width": "5rem"
                            }
                        }, "English", -1),
                        (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($gKT0D))),
                            alt: "avatar",
                            class: "w-16 h-16 check-icon"
                        }, null, -1)
                    ])
                ], 2),
                (0, $ecd4d.createElementVNode)("a", {
                    class: (0, $ecd4d.normalizeClass)([
                        "d-flex gap-16 align-items-center text-00365b entry",
                        {
                            'entry-active': $setup.currentLang === 'zh'
                        }
                    ]),
                    style: {
                        "padding": "0.5rem 1.5rem"
                    },
                    "data-lang": "zh",
                    onClick: _cache[2] || (_cache[2] = ($event)=>$setup.switchLanguage('zh'))
                }, [
                    ..._cache[5] || (_cache[5] = [
                        (0, $ecd4d.createElementVNode)("div", {
                            class: "flex-grow-1",
                            style: {
                                "width": "5rem"
                            }
                        }, "\u7B80\u4F53\u4E2D\u6587", -1),
                        (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($gKT0D))),
                            alt: "avatar",
                            class: "w-16 h-16 check-icon"
                        }, null, -1)
                    ])
                ], 2)
            ])
        ])
    ], 6);
}

});
parcelRegister("gHKAg", function(module, exports) {
module.exports = import.meta.resolve("8XlbV");

});

parcelRegister("gKT0D", function(module, exports) {
module.exports = import.meta.resolve("4knS8");

});


parcelRegister("iPEmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5c4d693ab55e0f$export$2e2bcd8739ae039);
let $db5c4d693ab55e0f$var$NOOP = ()=>{};
var $db5c4d693ab55e0f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("jBHLG", function(module, exports) {
module.exports = import.meta.resolve("ja09W");

});


parcelRegister("2wdrK", function(module, exports) {

$parcel$export(module.exports, "render", () => $1d59001eb9aae50a$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");

var $aCoHw = parcelRequire("aCoHw");

var $4Zqdg = parcelRequire("4Zqdg");

var $96HDp = parcelRequire("96HDp");

var $b91kF = parcelRequire("b91kF");

var $c1KNc = parcelRequire("c1KNc");
const $1d59001eb9aae50a$var$_hoisted_1 = {
    class: "vh-100 position-relative"
};
const $1d59001eb9aae50a$var$_hoisted_2 = {
    class: "container-fluid"
};
const $1d59001eb9aae50a$var$_hoisted_3 = {
    class: "row"
};
const $1d59001eb9aae50a$var$_hoisted_4 = {
    style: {
        "margin-top": "2.6rem",
        "padding-left": "8.14rem"
    },
    class: "text-white fw-normal mb-9 fs-28 login-section login-desc"
};
const $1d59001eb9aae50a$var$_hoisted_5 = {
    class: "col-sm-7 text-black w-100-sm"
};
const $1d59001eb9aae50a$var$_hoisted_6 = {
    class: "d-flex align-items-center h-custom-2 px-5 ms-xl-4 pt-5 pt-xl-0"
};
const $1d59001eb9aae50a$var$_hoisted_7 = {
    class: "fw-bold mb-0 fs-42",
    style: {
        "color": "#131313"
    }
};
const $1d59001eb9aae50a$var$_hoisted_8 = {
    class: "login-title"
};
const $1d59001eb9aae50a$var$_hoisted_9 = {
    class: "position-relative w-100 mb-3"
};
const $1d59001eb9aae50a$var$_hoisted_10 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "email"
};
const $1d59001eb9aae50a$var$_hoisted_11 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_12 = [
    "disabled",
    "placeholder"
];
const $1d59001eb9aae50a$var$_hoisted_13 = {
    class: "position-relative w-100 mb-3"
};
const $1d59001eb9aae50a$var$_hoisted_14 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "password"
};
const $1d59001eb9aae50a$var$_hoisted_15 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_16 = [
    "disabled",
    "placeholder"
];
const $1d59001eb9aae50a$var$_hoisted_17 = {
    key: 0,
    class: "position-relative w-100 mb-3"
};
const $1d59001eb9aae50a$var$_hoisted_18 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "mailAuthCode"
};
const $1d59001eb9aae50a$var$_hoisted_19 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_20 = [
    "placeholder"
];
const $1d59001eb9aae50a$var$_hoisted_21 = {
    class: "fw-bold fs-12 mt-8 text-right d-flex align-items-center justify-content-xxl-between user-select-none flex-wrap justify-content-sm-end"
};
const $1d59001eb9aae50a$var$_hoisted_22 = {
    class: "opacity-60"
};
const $1d59001eb9aae50a$var$_hoisted_23 = {
    class: "timer d-flex align-items-center"
};
const $1d59001eb9aae50a$var$_hoisted_24 = {
    key: 0
};
const $1d59001eb9aae50a$var$_hoisted_25 = {
    key: 1
};
const $1d59001eb9aae50a$var$_hoisted_26 = [
    "src"
];
const $1d59001eb9aae50a$var$_hoisted_27 = {
    key: 1,
    class: "register-area"
};
const $1d59001eb9aae50a$var$_hoisted_28 = {
    class: "position-relative w-100 mb-3"
};
const $1d59001eb9aae50a$var$_hoisted_29 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "confirmed-password"
};
const $1d59001eb9aae50a$var$_hoisted_30 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_31 = [
    "placeholder"
];
const $1d59001eb9aae50a$var$_hoisted_32 = {
    class: "position-relative w-100 mb-3"
};
const $1d59001eb9aae50a$var$_hoisted_33 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "auth-code"
};
const $1d59001eb9aae50a$var$_hoisted_34 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_35 = {
    class: "d-flex gap-3"
};
const $1d59001eb9aae50a$var$_hoisted_36 = [
    "placeholder"
];
const $1d59001eb9aae50a$var$_hoisted_37 = [
    "disabled"
];
const $1d59001eb9aae50a$var$_hoisted_38 = {
    class: "login-check form-check position-relative d-flex align-items-center"
};
const $1d59001eb9aae50a$var$_hoisted_39 = {
    class: "form-check-label d-flex align-items-center",
    for: "register_rules_checkbox"
};
const $1d59001eb9aae50a$var$_hoisted_40 = [
    "innerHTML"
];
const $1d59001eb9aae50a$var$_hoisted_41 = {
    class: "pt-1"
};
const $1d59001eb9aae50a$var$_hoisted_42 = [
    "disabled"
];
const $1d59001eb9aae50a$var$_hoisted_43 = [
    "disabled"
];
const $1d59001eb9aae50a$var$_hoisted_44 = [
    "disabled"
];
const $1d59001eb9aae50a$var$_hoisted_45 = {
    class: "modal fade",
    id: "resetInfoModal",
    tabindex: "-1",
    "aria-labelledby": "resetInfoModalLabel",
    "aria-hidden": "true"
};
const $1d59001eb9aae50a$var$_hoisted_46 = {
    class: "modal-dialog modal-dialog-centered",
    style: {
        "max-width": "30rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_47 = {
    class: "modal-content"
};
const $1d59001eb9aae50a$var$_hoisted_48 = {
    style: {
        "padding": "1.25rem 1.25rem 0.75rem",
        "border-bottom": "1px solid #D5DBE2"
    },
    class: "d-flex align-items-center justify-content-between"
};
const $1d59001eb9aae50a$var$_hoisted_49 = {
    id: "resetInfoModalLabel",
    class: "reset-title",
    style: {
        "font-weight": "700",
        "color": "#1c2124",
        "font-size": "1.125rem"
    }
};
const $1d59001eb9aae50a$var$_hoisted_50 = {
    style: {
        "padding": "1.5rem 1.5rem 2.5rem"
    },
    class: "reset-content"
};
function $1d59001eb9aae50a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)((0, $ecd4d.Fragment), null, [
        (0, $ecd4d.createElementVNode)("section", $1d59001eb9aae50a$var$_hoisted_1, [
            (0, $ecd4d.createVNode)($setup["LanguageSwitcher"], {
                class: "position-absolute top-20 right-0 me-0 border-0"
            }),
            (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_2, [
                (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_3, [
                    (0, $ecd4d.createElementVNode)("div", {
                        class: "col-sm-5 d-sm-flex vh-100 flex-column m-auto h-initial-sm login-left cursor-pointer remove-share",
                        style: {
                            "background-color": "#0068b0",
                            "padding-top": "12rem"
                        },
                        onClick: $setup.goHome
                    }, [
                        _cache[7] || (_cache[7] = (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($aCoHw))),
                            alt: "Login image",
                            style: {
                                "width": "18rem",
                                "padding-left": "8.14rem"
                            },
                            class: "login-logo login-section"
                        }, null, -1)),
                        (0, $ecd4d.createElementVNode)("p", $1d59001eb9aae50a$var$_hoisted_4, (0, $ecd4d.toDisplayString)($setup.$t('login.introduction')), 1),
                        _cache[8] || (_cache[8] = (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4Zqdg))),
                            alt: "Login",
                            style: {
                                "width": "25.875rem",
                                "height": "25.875rem",
                                "margin": "0 auto"
                            },
                            class: "login-desc-img"
                        }, null, -1))
                    ]),
                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_5, [
                        (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_6, [
                            (0, $ecd4d.createElementVNode)("form", {
                                style: {
                                    "width": "48rem"
                                },
                                class: "m-auto",
                                onSubmit: (0, $ecd4d.withModifiers)($setup.handleLogin, [
                                    "prevent"
                                ])
                            }, [
                                (0, $ecd4d.createElementVNode)("h1", $1d59001eb9aae50a$var$_hoisted_7, [
                                    (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_8, (0, $ecd4d.toDisplayString)($setup.mode === 'register' ? $setup.$t('login.newAccount') : $setup.$t('login.login')), 1)
                                ]),
                                (0, $ecd4d.createElementVNode)("span", {
                                    class: "d-inline-block register-tip fw-bold",
                                    style: {
                                        "margin-top": "0.89rem",
                                        "color": "#0068b0",
                                        "font-size": "1.33rem",
                                        "margin-bottom": "3rem",
                                        "cursor": "pointer"
                                    },
                                    onClick: $setup.toggleMode
                                }, (0, $ecd4d.toDisplayString)($setup.mode === 'register' ? $setup.$t('login.back') : $setup.$t('login.guideRegister')), 1),
                                (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_9, [
                                    (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_10, [
                                        _cache[9] || (_cache[9] = (0, $ecd4d.createElementVNode)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($96HDp))),
                                            alt: "email",
                                            style: {
                                                "width": "1.25rem"
                                            }
                                        }, null, -1)),
                                        (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_11, (0, $ecd4d.toDisplayString)($setup.$t('login.email')), 1)
                                    ]),
                                    (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event),
                                        disabled: $setup.isMailAuth,
                                        placeholder: $setup.$t('login.email'),
                                        type: "email",
                                        id: "email",
                                        class: (0, $ecd4d.normalizeClass)([
                                            "form-control form-control-lg w-100 text-1d2939",
                                            {
                                                'opacity-40': $setup.isMailAuth
                                            }
                                        ]),
                                        style: {
                                            "background-color": "#f8fbff",
                                            "border": "1px solid #c9defc"
                                        }
                                    }, null, 10, $1d59001eb9aae50a$var$_hoisted_12), [
                                        [
                                            (0, $ecd4d.vModelText),
                                            $setup.email
                                        ]
                                    ])
                                ]),
                                (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_13, [
                                    (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_14, [
                                        _cache[10] || (_cache[10] = (0, $ecd4d.createElementVNode)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b91kF))),
                                            alt: "email",
                                            style: {
                                                "width": "1.25rem"
                                            }
                                        }, null, -1)),
                                        (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_15, (0, $ecd4d.toDisplayString)($setup.$t('login.password')), 1)
                                    ]),
                                    (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event),
                                        disabled: $setup.isMailAuth,
                                        placeholder: $setup.$t('login.password'),
                                        type: "password",
                                        id: "password",
                                        class: (0, $ecd4d.normalizeClass)([
                                            {
                                                'opacity-40': $setup.isMailAuth
                                            },
                                            "form-control form-control-lg w-100 text-1d2939 password-input"
                                        ]),
                                        style: {
                                            "background-color": "#f8fbff",
                                            "border": "1px solid #c9defc"
                                        }
                                    }, null, 10, $1d59001eb9aae50a$var$_hoisted_16), [
                                        [
                                            (0, $ecd4d.vModelText),
                                            $setup.password
                                        ]
                                    ]),
                                    _cache[11] || (_cache[11] = (0, $ecd4d.createElementVNode)("div", {
                                        style: {
                                            "width": "1.5rem",
                                            "height": "1.5rem",
                                            "right": "1rem",
                                            "top": "2.55rem"
                                        },
                                        class: "position-absolute eye-icon d-none cursor-pointer"
                                    }, null, -1))
                                ]),
                                $setup.isMailAuth ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $1d59001eb9aae50a$var$_hoisted_17, [
                                    (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_18, [
                                        _cache[12] || (_cache[12] = (0, $ecd4d.createElementVNode)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($c1KNc))),
                                            alt: "verification",
                                            style: {
                                                "width": "1.25rem"
                                            }
                                        }, null, -1)),
                                        (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_19, (0, $ecd4d.toDisplayString)($setup.$t('login.verify')), 1)
                                    ]),
                                    (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.mailAuthCode = $event),
                                        onInput: $setup.onMailAuthCodeInput,
                                        type: "text",
                                        maxlength: "6",
                                        id: "mailAuthCode",
                                        placeholder: $setup.$t('login.inputVerify'),
                                        class: "form-control form-control-lg w-100 text-1d2939",
                                        style: {
                                            "background-color": "#f8fbff",
                                            "border": "1px solid #c9defc"
                                        }
                                    }, null, 40, $1d59001eb9aae50a$var$_hoisted_20), [
                                        [
                                            (0, $ecd4d.vModelText),
                                            $setup.mailAuthCode
                                        ]
                                    ]),
                                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_21, [
                                        (0, $ecd4d.createElementVNode)("span", {
                                            class: (0, $ecd4d.normalizeClass)([
                                                "text-ed3f34 mail-auth-tip",
                                                {
                                                    'd-none': !$setup.showMailAuthTip
                                                }
                                            ]),
                                            style: (0, $ecd4d.normalizeStyle)($setup.isMobile() ? {} : {
                                                visibility: $setup.showMailAuthTip ? 'visible' : 'hidden'
                                            })
                                        }, (0, $ecd4d.toDisplayString)($setup.$t('login.verifyNumber')), 7),
                                        (0, $ecd4d.createElementVNode)("div", {
                                            class: (0, $ecd4d.normalizeClass)([
                                                "text-primary d-flex align-items-center gap-1",
                                                {
                                                    'cursor-pointer': $setup.timerFinished
                                                }
                                            ]),
                                            onClick: _cache[3] || (_cache[3] = ($event)=>$setup.timerFinished && $setup.resendMailAuth())
                                        }, [
                                            (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_22, (0, $ecd4d.toDisplayString)($setup.$t('login.verifiSend')), 1),
                                            (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_23, [
                                                !$setup.timerFinished ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("span", $1d59001eb9aae50a$var$_hoisted_24, (0, $ecd4d.toDisplayString)($setup.timerCount) + "s", 1)) : ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("span", $1d59001eb9aae50a$var$_hoisted_25, [
                                                    (0, $ecd4d.createElementVNode)("img", {
                                                        src: $setup.iconNext,
                                                        alt: "next",
                                                        class: "icon-14"
                                                    }, null, 8, $1d59001eb9aae50a$var$_hoisted_26)
                                                ]))
                                            ])
                                        ], 2)
                                    ])
                                ])) : (0, $ecd4d.createCommentVNode)("", true),
                                $setup.mode === 'register' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $1d59001eb9aae50a$var$_hoisted_27, [
                                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_28, [
                                        (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_29, [
                                            _cache[13] || (_cache[13] = (0, $ecd4d.createElementVNode)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b91kF))),
                                                alt: "email",
                                                style: {
                                                    "width": "1.25rem"
                                                }
                                            }, null, -1)),
                                            (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_30, (0, $ecd4d.toDisplayString)($setup.$t('login.passwordConfirm')), 1)
                                        ]),
                                        (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.confirmPassword = $event),
                                            type: "password",
                                            id: "confirmed-password",
                                            class: "form-control form-control-lg w-100 password-input",
                                            style: {
                                                "background-color": "#f8fbff",
                                                "border": "1px solid #c9defc",
                                                "color": "#1d2939 !important"
                                            },
                                            placeholder: $setup.$t('login.passwordConfirm')
                                        }, null, 8, $1d59001eb9aae50a$var$_hoisted_31), [
                                            [
                                                (0, $ecd4d.vModelText),
                                                $setup.confirmPassword
                                            ]
                                        ]),
                                        _cache[14] || (_cache[14] = (0, $ecd4d.createElementVNode)("div", {
                                            style: {
                                                "width": "1.5rem",
                                                "height": "1.5rem",
                                                "right": "1rem",
                                                "top": "2.55rem"
                                            },
                                            class: "position-absolute eye-icon d-none cursor-pointer"
                                        }, null, -1))
                                    ]),
                                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_32, [
                                        (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_33, [
                                            _cache[15] || (_cache[15] = (0, $ecd4d.createElementVNode)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b91kF))),
                                                alt: "email",
                                                style: {
                                                    "width": "1.25rem"
                                                }
                                            }, null, -1)),
                                            (0, $ecd4d.createElementVNode)("span", $1d59001eb9aae50a$var$_hoisted_34, (0, $ecd4d.toDisplayString)($setup.$t('login.verifyText')), 1)
                                        ]),
                                        (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_35, [
                                            (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.authCode = $event),
                                                maxlength: "6",
                                                type: "text",
                                                id: "auth-code",
                                                class: "form-control form-control-lg w-75",
                                                style: {
                                                    "background-color": "#f8fbff",
                                                    "border": "1px solid #c9defc",
                                                    "color": "#1d2939 !important"
                                                },
                                                placeholder: $setup.$t('login.inputVerify')
                                            }, null, 8, $1d59001eb9aae50a$var$_hoisted_36), [
                                                [
                                                    (0, $ecd4d.vModelText),
                                                    $setup.authCode
                                                ]
                                            ]),
                                            (0, $ecd4d.createElementVNode)("button", {
                                                onClick: (0, $ecd4d.withModifiers)($setup.handleSendRegisterCode, [
                                                    "prevent"
                                                ]),
                                                type: "button",
                                                class: "btn btn-outline-primary fw-bold send-auth-code",
                                                "data-mdb-ripple-color": "dark",
                                                disabled: $setup.sendCodeLoading,
                                                style: {
                                                    "padding": "5px 1rem",
                                                    "font-size": "0.875rem",
                                                    "color": "#0068b0",
                                                    "border": "1px solid #0068b0",
                                                    "border-radius": "6px"
                                                }
                                            }, (0, $ecd4d.toDisplayString)($setup.$t('login.send')), 9, $1d59001eb9aae50a$var$_hoisted_37)
                                        ])
                                    ]),
                                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_38, [
                                        (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.agreeRules = $event),
                                            id: "register_rules_checkbox",
                                            class: "form-check-input",
                                            type: "checkbox"
                                        }, null, 512), [
                                            [
                                                (0, $ecd4d.vModelCheckbox),
                                                $setup.agreeRules
                                            ]
                                        ]),
                                        (0, $ecd4d.createElementVNode)("label", $1d59001eb9aae50a$var$_hoisted_39, [
                                            (0, $ecd4d.createElementVNode)("span", {
                                                innerHTML: $setup.termsHtml
                                            }, null, 8, $1d59001eb9aae50a$var$_hoisted_40)
                                        ])
                                    ])
                                ])) : (0, $ecd4d.createCommentVNode)("", true),
                                (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_41, [
                                    $setup.mode === 'login' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("button", {
                                        key: 0,
                                        onClick: (0, $ecd4d.withModifiers)($setup.handleLogin, [
                                            "prevent"
                                        ]),
                                        class: "btn btn-lg btn-block fw-bold text-white login-btn",
                                        style: {
                                            "background-color": "#0068b0",
                                            "font-size": "0.875rem",
                                            "padding": "0.5rem 1rem"
                                        },
                                        type: "button",
                                        disabled: $setup.loading
                                    }, (0, $ecd4d.toDisplayString)($setup.isMailAuth ? $setup.$t('login.go') : $setup.$t('login.login')), 9, $1d59001eb9aae50a$var$_hoisted_42)) : ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("button", {
                                        key: 1,
                                        onClick: (0, $ecd4d.withModifiers)($setup.handleRegister, [
                                            "prevent"
                                        ]),
                                        class: "btn btn-lg btn-block text-white register-btn fw-bold",
                                        style: {
                                            "background-color": "#0068b0",
                                            "font-size": "0.875rem"
                                        },
                                        type: "button",
                                        disabled: $setup.loading
                                    }, (0, $ecd4d.toDisplayString)($setup.$t('login.register')), 9, $1d59001eb9aae50a$var$_hoisted_43)),
                                    (0, $ecd4d.createElementVNode)("button", {
                                        onClick: (0, $ecd4d.withModifiers)($setup.handleResetPassword, [
                                            "prevent"
                                        ]),
                                        class: (0, $ecd4d.normalizeClass)([
                                            "btn btn-lg btn-block text-white btn-reset-password fw-bold",
                                            {
                                                'd-none': !$setup.showResetPasswordBtn
                                            }
                                        ]),
                                        style: {
                                            "background-color": "#0068b0",
                                            "font-size": "0.875rem"
                                        },
                                        type: "button",
                                        disabled: $setup.loading
                                    }, (0, $ecd4d.toDisplayString)($setup.$t('login.resetPassword')), 11, $1d59001eb9aae50a$var$_hoisted_44)
                                ]),
                                $setup.mode !== 'register' && !$setup.isMailAuth ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("span", {
                                    key: 2,
                                    class: "d-inline-block fw-bold btn-forgot-password",
                                    style: {
                                        "margin-top": "1.33rem",
                                        "color": "#0068b0",
                                        "font-size": "0.75rem",
                                        "margin-bottom": "8.89rem",
                                        "cursor": "pointer"
                                    },
                                    onClick: (0, $ecd4d.withModifiers)($setup.handleForgotPassword, [
                                        "prevent"
                                    ])
                                }, (0, $ecd4d.toDisplayString)($setup.$t('login.forgetPassword')), 1)) : (0, $ecd4d.createCommentVNode)("", true)
                            ], 32)
                        ])
                    ])
                ])
            ])
        ]),
        (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_45, [
            (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_46, [
                (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_47, [
                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_48, [
                        (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_49, (0, $ecd4d.toDisplayString)($setup.$t('common.normalTip')), 1),
                        _cache[16] || (_cache[16] = (0, $ecd4d.createElementVNode)("button", {
                            type: "button",
                            class: "btn-close",
                            "aria-label": "Close",
                            "data-mdb-dismiss": "modal"
                        }, null, -1))
                    ]),
                    (0, $ecd4d.createElementVNode)("div", $1d59001eb9aae50a$var$_hoisted_50, (0, $ecd4d.toDisplayString)($setup.$t('login.alert.info')), 1)
                ])
            ])
        ])
    ], 64);
}

});
parcelRegister("aCoHw", function(module, exports) {
module.exports = import.meta.resolve("josgK");

});

parcelRegister("4Zqdg", function(module, exports) {
module.exports = import.meta.resolve("8Y8Qi");

});

parcelRegister("96HDp", function(module, exports) {
module.exports = import.meta.resolve("8edzf");

});

parcelRegister("b91kF", function(module, exports) {
module.exports = import.meta.resolve("lGP4g");

});

parcelRegister("c1KNc", function(module, exports) {
module.exports = import.meta.resolve("4ilX2");

});


parcelRegister("71t6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $51cf33e6766657e8$export$2e2bcd8739ae039);
let $51cf33e6766657e8$var$NOOP = ()=>{};
var $51cf33e6766657e8$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("aEG6O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7c1e4dbc701ae425$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $iS8eH = parcelRequire("iS8eH");

var $klH19 = parcelRequire("klH19");

var $h8sKa = parcelRequire("h8sKa");

var $6lxfX = parcelRequire("6lxfX");
var $7c1e4dbc701ae425$export$2e2bcd8739ae039 = {
    __name: 'ResetPassword',
    setup (__props, { expose: __expose }) {
        __expose();
        const email = (0, $ecd4d.ref)('');
        const password = (0, $ecd4d.ref)('');
        const confirmPassword = (0, $ecd4d.ref)('');
        const loading = (0, $ecd4d.ref)(false);
        const pageState = (0, $ecd4d.ref)('loading') // loading | ready | invalid | notfound
        ;
        const resetToken = (0, $ecd4d.ref)('');
        const toast = new (0, $6lxfX.default)();
        const eyeIconEventHandlers = new Map();
        const $t = (0, $iS8eH.default).global.t;
        const isValidPassword = (pwd)=>/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9%_+\-.]{10,50}$/.test(pwd || '');
        const goLogin = ()=>{
            window.location.href = '/login.html';
        };
        const goHome = ()=>{
            window.location.href = '/';
        };
        const updateTitle = (state)=>{
            if (state === 'ready') document.title = `${$t('login.resetPassword')} Scanat`;
            else if (state === 'invalid') document.title = `${$t('title.link.useless')}`;
            else if (state === 'notfound') document.title = `${$t('title.link.notExist')}`;
        };
        (0, $ecd4d.watchEffect)(()=>{
            updateTitle(pageState.value);
        });
        const setupPasswordEyeIcon = ()=>{
            const passwordEl = document.getElementById('password');
            const confirmPasswordEl = document.getElementById('confirmed-password');
            const eyeIcons = document.querySelectorAll('.eye-icon');
            eyeIcons.forEach((eyeIcon, index)=>{
                if (eyeIconEventHandlers.has(eyeIcon)) {
                    const handlers = eyeIconEventHandlers.get(eyeIcon);
                    eyeIcon.removeEventListener('mouseover', handlers.mouseover);
                    eyeIcon.removeEventListener('mouseout', handlers.mouseout);
                    eyeIconEventHandlers.delete(eyeIcon);
                }
                const targetInput = index === 0 ? passwordEl : confirmPasswordEl;
                if (!targetInput) return;
                const mouseoverHandler = ()=>{
                    if (targetInput.type === 'password') targetInput.type = 'text';
                };
                const mouseoutHandler = ()=>{
                    if (targetInput.type === 'text') targetInput.type = 'password';
                };
                eyeIcon.addEventListener('mouseover', mouseoverHandler);
                eyeIcon.addEventListener('mouseout', mouseoutHandler);
                eyeIconEventHandlers.set(eyeIcon, {
                    mouseover: mouseoverHandler,
                    mouseout: mouseoutHandler
                });
            });
        };
        const handleReset = async ()=>{
            if (!email.value || !password.value || !confirmPassword.value) {
                toast.toast('danger', $t('login.noEmpty'));
                return;
            }
            if (!isValidPassword(password.value) || !isValidPassword(confirmPassword.value)) {
                toast.toast('danger', $t('login.passwordTip'));
                return;
            }
            if (!(0, $h8sKa.isEmail)(email.value)) {
                toast.toast('danger', $t('login.emailError'));
                return;
            }
            loading.value = true;
            const res = await (0, $h8sKa.request)('auth/portal/reset_password', {
                email: email.value,
                password: password.value,
                confirmPassword: confirmPassword.value,
                key: resetToken.value
            }, false);
            loading.value = false;
            if (res?.code === 200) toast.toast('success', $t('login.resetPasswordSuccess'), false, {
                callback: ()=>{
                    window.location.href = '/login.html';
                }
            });
            else if (res?.code === 412) {
                pageState.value = 'invalid';
                updateTitle('invalid');
            } else if (res?.code === 413) {
                pageState.value = 'notfound';
                updateTitle('notfound');
            }
        };
        const initByToken = async ()=>{
            const params = new URLSearchParams(window.location.search);
            const token = params.get('token') || '';
            resetToken.value = token;
            if (!token) {
                pageState.value = 'notfound';
                updateTitle('notfound');
                return;
            }
            try {
                const res = await (0, $h8sKa.request)('auth/checkResetPasswordKey', {
                    key: token
                }, false);
                if (res?.code === 200) {
                    email.value = res?.data || '';
                    pageState.value = 'ready';
                    updateTitle('ready');
                    await (0, $ecd4d.nextTick)();
                    setupPasswordEyeIcon();
                } else if (res?.code === 412) {
                    pageState.value = 'invalid';
                    updateTitle('invalid');
                } else if (res?.code === 413) {
                    pageState.value = 'notfound';
                    updateTitle('notfound');
                } else {
                    pageState.value = 'invalid';
                    updateTitle('invalid');
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        };
        (0, $ecd4d.onMounted)(()=>{
            initByToken();
        });
        const __returned__ = {
            email: email,
            password: password,
            confirmPassword: confirmPassword,
            loading: loading,
            pageState: pageState,
            resetToken: resetToken,
            toast: toast,
            eyeIconEventHandlers: eyeIconEventHandlers,
            $t: $t,
            isValidPassword: isValidPassword,
            goLogin: goLogin,
            goHome: goHome,
            updateTitle: updateTitle,
            setupPasswordEyeIcon: setupPasswordEyeIcon,
            handleReset: handleReset,
            initByToken: initByToken,
            nextTick: $ecd4d.nextTick,
            onMounted: $ecd4d.onMounted,
            ref: $ecd4d.ref,
            watchEffect: $ecd4d.watchEffect,
            get i18n () {
                return 0, $iS8eH.default;
            },
            LanguageSwitcher: $klH19.default,
            get isEmail () {
                return 0, $h8sKa.isEmail;
            },
            get request () {
                return 0, $h8sKa.request;
            },
            get Toast () {
                return 0, $6lxfX.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("766Bb", function(module, exports) {

$parcel$export(module.exports, "render", () => $52ae364c433b9c65$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");

var $aCoHw = parcelRequire("aCoHw");

var $4Zqdg = parcelRequire("4Zqdg");

var $96HDp = parcelRequire("96HDp");

var $b91kF = parcelRequire("b91kF");

var $3nVlx = parcelRequire("3nVlx");

var $6LroJ = parcelRequire("6LroJ");

var $aUO4b = parcelRequire("aUO4b");
const $52ae364c433b9c65$var$_hoisted_1 = {
    key: 0,
    class: "vh-100 position-relative"
};
const $52ae364c433b9c65$var$_hoisted_2 = {
    class: "container-fluid"
};
const $52ae364c433b9c65$var$_hoisted_3 = {
    class: "row"
};
const $52ae364c433b9c65$var$_hoisted_4 = {
    style: {
        "margin-top": "2.6rem",
        "padding-left": "8.14rem"
    },
    class: "text-white fw-normal mb-9 fs-28 login-section login-desc"
};
const $52ae364c433b9c65$var$_hoisted_5 = {
    class: "col-sm-7 text-black w-100-sm"
};
const $52ae364c433b9c65$var$_hoisted_6 = {
    class: "d-flex align-items-center h-custom-2 px-5 ms-xl-4 pt-5 pt-xl-0"
};
const $52ae364c433b9c65$var$_hoisted_7 = {
    class: "fw-bold mb-0 fs-42",
    style: {
        "color": "#131313"
    }
};
const $52ae364c433b9c65$var$_hoisted_8 = {
    class: "position-relative w-100 mb-3",
    style: {
        "margin-top": "1.5rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_9 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "email"
};
const $52ae364c433b9c65$var$_hoisted_10 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_11 = {
    class: "position-relative w-100 mb-3"
};
const $52ae364c433b9c65$var$_hoisted_12 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "password"
};
const $52ae364c433b9c65$var$_hoisted_13 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_14 = {
    class: "position-relative w-100 mb-3"
};
const $52ae364c433b9c65$var$_hoisted_15 = {
    class: "form-label d-flex align-items-center",
    style: {
        "gap": "0.89rem"
    },
    for: "confirmed-password"
};
const $52ae364c433b9c65$var$_hoisted_16 = {
    style: {
        "color": "#3f4855",
        "font-size": "0.875rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_17 = {
    class: "pt-1"
};
const $52ae364c433b9c65$var$_hoisted_18 = [
    "disabled"
];
const $52ae364c433b9c65$var$_hoisted_19 = {
    key: 1
};
const $52ae364c433b9c65$var$_hoisted_20 = {
    class: "navbar navbar-expand-lg navbar-light",
    style: {
        "box-shadow": "none"
    }
};
const $52ae364c433b9c65$var$_hoisted_21 = {
    class: "container-fluid pe-0"
};
const $52ae364c433b9c65$var$_hoisted_22 = {
    class: "position-relative min-vh-100 d-flex align-items-center justify-content-center",
    style: {
        "background-image": "url('../assets/landing/bg.svg')",
        "background-size": "cover"
    }
};
const $52ae364c433b9c65$var$_hoisted_23 = {
    class: "text-center"
};
const $52ae364c433b9c65$var$_hoisted_24 = {
    key: 0,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($6LroJ))),
    alt: "Link Invalid",
    style: {
        "width": "200px",
        "height": "175px"
    }
};
const $52ae364c433b9c65$var$_hoisted_25 = {
    key: 1,
    src: (0, (/*@__PURE__*/$parcel$interopDefault($aUO4b))),
    alt: "Link Not Found",
    style: {
        "width": "200px",
        "height": "175px"
    }
};
const $52ae364c433b9c65$var$_hoisted_26 = {
    key: 2,
    style: {
        "font-size": "1.25rem",
        "font-weight": "700",
        "color": "#1c2124",
        "margin-top": "2rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_27 = {
    key: 3,
    style: {
        "margin-top": "0.75rem",
        "color": "#6b7280"
    }
};
const $52ae364c433b9c65$var$_hoisted_28 = {
    key: 4,
    style: {
        "font-size": "1.25rem",
        "font-weight": "700",
        "color": "#1c2124",
        "margin-top": "2rem"
    }
};
const $52ae364c433b9c65$var$_hoisted_29 = {
    key: 5,
    style: {
        "margin-top": "0.75rem",
        "color": "#6b7280"
    }
};
function $52ae364c433b9c65$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.pageState === 'ready' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("section", $52ae364c433b9c65$var$_hoisted_1, [
        (0, $ecd4d.createVNode)($setup["LanguageSwitcher"], {
            class: "position-absolute top-20 right-0 me-0 border-0"
        }),
        (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_2, [
            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_3, [
                (0, $ecd4d.createElementVNode)("div", {
                    class: "col-sm-5 d-sm-flex vh-100 flex-column m-auto h-initial-sm login-left cursor-pointer remove-share",
                    style: {
                        "background-color": "#0068b0",
                        "padding-top": "12rem"
                    },
                    onClick: $setup.goHome
                }, [
                    _cache[3] || (_cache[3] = (0, $ecd4d.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($aCoHw))),
                        alt: "Login image",
                        style: {
                            "width": "18rem",
                            "padding-left": "8.14rem"
                        },
                        class: "login-logo login-section"
                    }, null, -1)),
                    (0, $ecd4d.createElementVNode)("p", $52ae364c433b9c65$var$_hoisted_4, (0, $ecd4d.toDisplayString)($setup.$t('login.introduction')), 1),
                    _cache[4] || (_cache[4] = (0, $ecd4d.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($4Zqdg))),
                        alt: "Login",
                        style: {
                            "width": "25.875rem",
                            "height": "25.875rem",
                            "margin": "0 auto"
                        },
                        class: "login-desc-img"
                    }, null, -1))
                ]),
                (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_5, [
                    (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_6, [
                        (0, $ecd4d.createElementVNode)("form", {
                            style: {
                                "width": "48rem"
                            },
                            class: "m-auto",
                            onSubmit: (0, $ecd4d.withModifiers)($setup.handleReset, [
                                "prevent"
                            ])
                        }, [
                            (0, $ecd4d.createElementVNode)("h1", $52ae364c433b9c65$var$_hoisted_7, [
                                (0, $ecd4d.createElementVNode)("span", null, (0, $ecd4d.toDisplayString)($setup.$t('login.resetPassword')), 1)
                            ]),
                            (0, $ecd4d.createElementVNode)("span", {
                                onClick: (0, $ecd4d.withModifiers)($setup.goLogin, [
                                    "prevent"
                                ]),
                                class: "d-inline-block register-tip fw-bold",
                                style: {
                                    "margin-top": "0.89rem",
                                    "color": "#0068b0",
                                    "font-size": "1.33rem",
                                    "margin-bottom": "3rem",
                                    "cursor": "pointer"
                                }
                            }, (0, $ecd4d.toDisplayString)($setup.$t('login.back')), 1),
                            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_8, [
                                (0, $ecd4d.createElementVNode)("label", $52ae364c433b9c65$var$_hoisted_9, [
                                    _cache[5] || (_cache[5] = (0, $ecd4d.createElementVNode)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($96HDp))),
                                        alt: "email",
                                        style: {
                                            "width": "1.25rem"
                                        }
                                    }, null, -1)),
                                    (0, $ecd4d.createElementVNode)("span", $52ae364c433b9c65$var$_hoisted_10, (0, $ecd4d.toDisplayString)($setup.$t('login.email')), 1)
                                ]),
                                (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                    type: "email",
                                    id: "email",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.email = $event),
                                    disabled: "",
                                    class: "form-control form-control-lg w-100 text-1d2939",
                                    style: {
                                        "background-color": "#ECEFF2",
                                        "border": "1px solid #c9defc"
                                    }
                                }, null, 512), [
                                    [
                                        (0, $ecd4d.vModelText),
                                        $setup.email
                                    ]
                                ])
                            ]),
                            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_11, [
                                (0, $ecd4d.createElementVNode)("label", $52ae364c433b9c65$var$_hoisted_12, [
                                    _cache[6] || (_cache[6] = (0, $ecd4d.createElementVNode)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b91kF))),
                                        alt: "email",
                                        style: {
                                            "width": "1.25rem"
                                        }
                                    }, null, -1)),
                                    (0, $ecd4d.createElementVNode)("span", $52ae364c433b9c65$var$_hoisted_13, (0, $ecd4d.toDisplayString)($setup.$t('login.password')), 1)
                                ]),
                                (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                    type: "password",
                                    id: "password",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.password = $event),
                                    class: "form-control form-control-lg w-100 text-1d2939 password-input",
                                    style: {
                                        "background-color": "#f8fbff",
                                        "border": "1px solid #c9defc"
                                    }
                                }, null, 512), [
                                    [
                                        (0, $ecd4d.vModelText),
                                        $setup.password
                                    ]
                                ]),
                                _cache[7] || (_cache[7] = (0, $ecd4d.createElementVNode)("div", {
                                    style: {
                                        "width": "1.5rem",
                                        "height": "1.5rem",
                                        "right": "1rem",
                                        "top": "2.55rem"
                                    },
                                    class: "position-absolute eye-icon d-none cursor-pointer"
                                }, null, -1))
                            ]),
                            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_14, [
                                (0, $ecd4d.createElementVNode)("label", $52ae364c433b9c65$var$_hoisted_15, [
                                    _cache[8] || (_cache[8] = (0, $ecd4d.createElementVNode)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b91kF))),
                                        alt: "email",
                                        style: {
                                            "width": "1.25rem"
                                        }
                                    }, null, -1)),
                                    (0, $ecd4d.createElementVNode)("span", $52ae364c433b9c65$var$_hoisted_16, (0, $ecd4d.toDisplayString)($setup.$t('login.passwordConfirm')), 1)
                                ]),
                                (0, $ecd4d.withDirectives)((0, $ecd4d.createElementVNode)("input", {
                                    type: "password",
                                    id: "confirmed-password",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.confirmPassword = $event),
                                    class: "form-control form-control-lg w-100 text-1d2939 password-input",
                                    style: {
                                        "background-color": "#f8fbff",
                                        "border": "1px solid #c9defc"
                                    }
                                }, null, 512), [
                                    [
                                        (0, $ecd4d.vModelText),
                                        $setup.confirmPassword
                                    ]
                                ]),
                                _cache[9] || (_cache[9] = (0, $ecd4d.createElementVNode)("div", {
                                    style: {
                                        "width": "1.5rem",
                                        "height": "1.5rem",
                                        "right": "1rem",
                                        "top": "2.55rem"
                                    },
                                    class: "position-absolute eye-icon d-none cursor-pointer"
                                }, null, -1))
                            ]),
                            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_17, [
                                (0, $ecd4d.createElementVNode)("button", {
                                    onClick: (0, $ecd4d.withModifiers)($setup.handleReset, [
                                        "prevent"
                                    ]),
                                    class: "btn btn-lg btn-block fw-bold text-white btn-reset-password",
                                    style: {
                                        "background-color": "#0068b0",
                                        "font-size": "0.875rem"
                                    },
                                    type: "button",
                                    disabled: $setup.loading
                                }, (0, $ecd4d.toDisplayString)($setup.$t('login.resetPassword')), 9, $52ae364c433b9c65$var$_hoisted_18)
                            ])
                        ], 32)
                    ])
                ])
            ])
        ])
    ])) : $setup.pageState === 'invalid' || $setup.pageState === 'notfound' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $52ae364c433b9c65$var$_hoisted_19, [
        (0, $ecd4d.createElementVNode)("nav", $52ae364c433b9c65$var$_hoisted_20, [
            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_21, [
                _cache[10] || (_cache[10] = (0, $ecd4d.createElementVNode)("a", {
                    class: "navbar-brand mt-2 mt-lg-0",
                    href: "/",
                    style: {
                        "margin-left": "0.5rem"
                    }
                }, [
                    (0, $ecd4d.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3nVlx))),
                        width: "168",
                        height: "32",
                        alt: "SCANAT Logo",
                        loading: "lazy"
                    })
                ], -1)),
                (0, $ecd4d.createVNode)($setup["LanguageSwitcher"], {
                    class: "border-0 me-0"
                })
            ])
        ]),
        (0, $ecd4d.createElementVNode)("section", $52ae364c433b9c65$var$_hoisted_22, [
            (0, $ecd4d.createElementVNode)("div", $52ae364c433b9c65$var$_hoisted_23, [
                $setup.pageState === 'invalid' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("img", $52ae364c433b9c65$var$_hoisted_24)) : ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("img", $52ae364c433b9c65$var$_hoisted_25)),
                $setup.pageState === 'invalid' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $52ae364c433b9c65$var$_hoisted_26, (0, $ecd4d.toDisplayString)($setup.$t('login.invalid.info')), 1)) : (0, $ecd4d.createCommentVNode)("", true),
                $setup.pageState === 'invalid' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $52ae364c433b9c65$var$_hoisted_27, (0, $ecd4d.toDisplayString)($setup.$t('login.invalid.tip')), 1)) : (0, $ecd4d.createCommentVNode)("", true),
                $setup.pageState === 'notfound' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $52ae364c433b9c65$var$_hoisted_28, (0, $ecd4d.toDisplayString)($setup.$t('login.noExist.info')), 1)) : (0, $ecd4d.createCommentVNode)("", true),
                $setup.pageState === 'notfound' ? ((0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", $52ae364c433b9c65$var$_hoisted_29, (0, $ecd4d.toDisplayString)($setup.$t('login.noExist.tip')), 1)) : (0, $ecd4d.createCommentVNode)("", true)
            ])
        ])
    ])) : (0, $ecd4d.createCommentVNode)("", true);
}

});
parcelRegister("3nVlx", function(module, exports) {
module.exports = import.meta.resolve("0RDmo");

});

parcelRegister("6LroJ", function(module, exports) {
module.exports = import.meta.resolve("2GD7a");

});

parcelRegister("aUO4b", function(module, exports) {
module.exports = import.meta.resolve("ePIha");

});


parcelRegister("fo24w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b33ab4530af97ab9$export$2e2bcd8739ae039);
let $b33ab4530af97ab9$var$NOOP = ()=>{};
var $b33ab4530af97ab9$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8F92D", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $64e92a890d7ef98b$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $klH19 = parcelRequire("klH19");

var $aZsCH = parcelRequire("aZsCH");

var $iS8eH = parcelRequire("iS8eH");

var $7IP4a = parcelRequire("7IP4a");
var $64e92a890d7ef98b$export$2e2bcd8739ae039 = {
    __name: 'Landing',
    setup (__props, { expose: __expose }) {
        __expose();
        const $t = (0, $iS8eH.default).global.t;
        (0, $ecd4d.watchEffect)(()=>{
            document.title = $t('landing.select');
        });
        const __returned__ = {
            $t: $t,
            watchEffect: $ecd4d.watchEffect,
            LanguageSwitcher: $klH19.default,
            ModalNoPermission: $aZsCH.default,
            get i18n () {
                return 0, $iS8eH.default;
            },
            get webSvgUrl () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($7IP4a));
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("aZsCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8005cdd596be522a$export$2e2bcd8739ae039);
let $8005cdd596be522a$var$script;



let $8005cdd596be522a$var$initialize = ()=>{
    $8005cdd596be522a$var$script = (parcelRequire("8MKca"));
    if ($8005cdd596be522a$var$script.__esModule) $8005cdd596be522a$var$script = $8005cdd596be522a$var$script.default;
    $8005cdd596be522a$var$script.render = (parcelRequire("hNehk")).render;
    (parcelRequire("h0iNg")).default($8005cdd596be522a$var$script);
    $8005cdd596be522a$var$script.__scopeId = 'data-v-703d7a';
    $8005cdd596be522a$var$script.__file = "ModalNoPermission.vue";
};
$8005cdd596be522a$var$initialize();
var $8005cdd596be522a$export$2e2bcd8739ae039 = $8005cdd596be522a$var$script;

});
parcelRegister("8MKca", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6656a3d7d313becf$export$2e2bcd8739ae039);

var $ecd4d = parcelRequire("ecd4d");

var $iS8eH = parcelRequire("iS8eH");
var $6656a3d7d313becf$export$2e2bcd8739ae039 = {
    __name: 'ModalNoPermission',
    setup (__props, { expose: __expose }) {
        __expose();
        const $t = (0, $iS8eH.default).global.t;
        const noPermissionMessage = (0, $ecd4d.computed)(()=>{
            return $t('landing.alertNoPlan').replace(/<link>(.*?)<\/link>/g, '<a target="_blank" style="text-decoration:underline;" href="https://www.natincs.com/contact/">$1</a>');
        });
        const handleModalClose = ()=>{
            if (!window.location.href.includes('models.html')) return;
            window.location.href = '/landing.html';
        };
        (0, $ecd4d.onMounted)(()=>{
            const modal = document.getElementById('noPermissionModal');
            if (modal) modal.addEventListener('hidden.mdb.modal', handleModalClose);
        });
        (0, $ecd4d.onUnmounted)(()=>{
            const modal = document.getElementById('noPermissionModal');
            if (modal) modal.removeEventListener('hidden.mdb.modal', handleModalClose);
        });
        const __returned__ = {
            $t: $t,
            noPermissionMessage: noPermissionMessage,
            handleModalClose: handleModalClose,
            computed: $ecd4d.computed,
            Teleport: $ecd4d.Teleport,
            onMounted: $ecd4d.onMounted,
            onUnmounted: $ecd4d.onUnmounted,
            get i18n () {
                return 0, $iS8eH.default;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("hNehk", function(module, exports) {

$parcel$export(module.exports, "render", () => $cf4216ab1a87b331$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");

var $ltpdW = parcelRequire("ltpdW");
const $cf4216ab1a87b331$var$_hoisted_1 = {
    class: "modal fade",
    id: "noPermissionModal",
    tabindex: "-1"
};
const $cf4216ab1a87b331$var$_hoisted_2 = {
    class: "modal-dialog modal-dialog-centered mx-auto",
    style: {
        "width": "21.25rem"
    }
};
const $cf4216ab1a87b331$var$_hoisted_3 = {
    class: "modal-content p-24"
};
const $cf4216ab1a87b331$var$_hoisted_4 = {
    class: "modal-body text-00365b fs-14 d-flex flex-column gap-12 p-0 align-items-center"
};
const $cf4216ab1a87b331$var$_hoisted_5 = [
    "innerHTML"
];
const $cf4216ab1a87b331$var$_hoisted_6 = {
    class: "modal-footer border-0 p-0 mt-24"
};
const $cf4216ab1a87b331$var$_hoisted_7 = {
    type: "button",
    class: "btn-secondary small border-0 m-0 text-white fw-bold fs-14 w-100 b-r-4 bg-primary",
    "data-mdb-dismiss": "modal",
    style: {
        "padding": "5px 1rem",
        "font-weight": "500"
    }
};
function $cf4216ab1a87b331$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createBlock)((0, $ecd4d.Teleport), {
        to: "body"
    }, [
        (0, $ecd4d.createElementVNode)("div", $cf4216ab1a87b331$var$_hoisted_1, [
            (0, $ecd4d.createElementVNode)("div", $cf4216ab1a87b331$var$_hoisted_2, [
                (0, $ecd4d.createElementVNode)("div", $cf4216ab1a87b331$var$_hoisted_3, [
                    (0, $ecd4d.createElementVNode)("div", $cf4216ab1a87b331$var$_hoisted_4, [
                        _cache[0] || (_cache[0] = (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ltpdW))),
                            alt: "warning",
                            style: {
                                "width": "5rem",
                                "height": "5rem"
                            }
                        }, null, -1)),
                        (0, $ecd4d.createElementVNode)("span", {
                            innerHTML: $setup.noPermissionMessage
                        }, null, 8, $cf4216ab1a87b331$var$_hoisted_5)
                    ]),
                    (0, $ecd4d.createElementVNode)("div", $cf4216ab1a87b331$var$_hoisted_6, [
                        (0, $ecd4d.createElementVNode)("button", $cf4216ab1a87b331$var$_hoisted_7, (0, $ecd4d.toDisplayString)($setup.$t('common.close')), 1)
                    ])
                ])
            ])
        ])
    ]);
}

});
parcelRegister("ltpdW", function(module, exports) {
module.exports = import.meta.resolve("isdeX");

});


parcelRegister("h0iNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c61103c3221e55e4$export$2e2bcd8739ae039);
let $c61103c3221e55e4$var$NOOP = ()=>{};
var $c61103c3221e55e4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7IP4a", function(module, exports) {
module.exports = import.meta.resolve("5jHUp");

});


parcelRegister("2qsAR", function(module, exports) {

$parcel$export(module.exports, "render", () => $1c443093cf604a79$export$b3890eb0ae9dca99);

var $ecd4d = parcelRequire("ecd4d");

var $3nVlx = parcelRequire("3nVlx");

var $iaZWL = parcelRequire("iaZWL");

var $6b4pF = parcelRequire("6b4pF");

var $fj6mT = parcelRequire("fj6mT");

var $iU45Q = parcelRequire("iU45Q");

var $lJVOw = parcelRequire("lJVOw");

var $lAm4W = parcelRequire("lAm4W");

var $cB4N0 = parcelRequire("cB4N0");

var $991OD = parcelRequire("991OD");
const $1c443093cf604a79$var$_hoisted_1 = {
    class: "position-sticky top-0 bg-transparent",
    style: {
        "z-index": "999"
    }
};
const $1c443093cf604a79$var$_hoisted_2 = {
    class: "navbar navbar-expand-lg navbar-light",
    style: {
        "box-shadow": "none"
    }
};
const $1c443093cf604a79$var$_hoisted_3 = {
    class: "container-fluid px-24"
};
const $1c443093cf604a79$var$_hoisted_4 = {
    class: "d-flex align-items-center",
    style: {
        "margin-right": "1.25rem"
    }
};
const $1c443093cf604a79$var$_hoisted_5 = {
    class: "dropdown"
};
const $1c443093cf604a79$var$_hoisted_6 = {
    class: "dropdown-menu dropdown-menu-end mt-10",
    "aria-labelledby": "navbarDropdownMenuAvatar",
    style: {
        "border": "1px solid #dadada",
        "box-shadow": "0 10px 32px 0 #00365b1a",
        "border-radius": "0.5rem",
        "padding": "0.75rem 1rem 1rem",
        "min-width": "12.5rem"
    }
};
const $1c443093cf604a79$var$_hoisted_7 = {
    style: {
        "padding-bottom": "0.75rem",
        "padding-top": "0.75rem"
    },
    class: "d-flex gap-12 cursor-pointer align-items-center mt-8 navbar-item navbar-web remove-share"
};
const $1c443093cf604a79$var$_hoisted_8 = {
    class: "fs-14 text-335e7c"
};
const $1c443093cf604a79$var$_hoisted_9 = {
    style: {
        "padding-bottom": "0.75rem",
        "padding-top": "0.75rem"
    },
    class: "d-flex gap-12 cursor-pointer align-items-center mb-8px navbar-item navbar-dashboard remove-share"
};
const $1c443093cf604a79$var$_hoisted_10 = {
    class: "fs-14 text-335e7c"
};
const $1c443093cf604a79$var$_hoisted_11 = {
    class: "text-center"
};
const $1c443093cf604a79$var$_hoisted_12 = {
    type: "button",
    class: "btn-outline-primary btn btn-logout w-100",
    "data-mdb-ripple-color": "dark",
    style: {
        "font-weight": "500",
        "font-size": "0.875rem",
        "border": "1px solid #0068b0",
        "border-radius": "6px",
        "padding": "5px 1rem",
        "color": "#0068b0"
    }
};
const $1c443093cf604a79$var$_hoisted_13 = {
    style: {
        "margin-top": "16vh",
        "padding-bottom": "8rem"
    },
    class: "d-flex justify-content-center flex-column align-items-center gap-48"
};
const $1c443093cf604a79$var$_hoisted_14 = {
    class: "fs-24 fw-bold text-1C2124"
};
const $1c443093cf604a79$var$_hoisted_15 = {
    class: "d-flex gap-72 position-relative"
};
const $1c443093cf604a79$var$_hoisted_16 = {
    class: "d-flex gap-24 flex-column b-r-8 bg-white landing-card cursor-pointer landing-dashboard",
    style: {
        "border": "1px solid #ebf3f9",
        "padding": "2rem 1.875rem 1.5625rem 1.875rem"
    }
};
const $1c443093cf604a79$var$_hoisted_17 = {
    class: "fs-20 text-00365b fw-bold mb-0 text-center",
    style: {
        "margin-top": "-6px"
    }
};
const $1c443093cf604a79$var$_hoisted_18 = {
    class: "fs-14 text-66869d lh-28 d-inline-block w-320",
    style: {
        "white-space": "pre-wrap"
    }
};
const $1c443093cf604a79$var$_hoisted_19 = {
    class: "d-flex gap-24 flex-column p-32 b-r-8 bg-white landing-card cursor-pointer landing-models position-relative",
    style: {
        "border": "1px solid #ebf3f9",
        "padding": "2rem 1.875rem 1.5625rem 1.875rem"
    }
};
const $1c443093cf604a79$var$_hoisted_20 = [
    "data"
];
const $1c443093cf604a79$var$_hoisted_21 = [
    "src"
];
const $1c443093cf604a79$var$_hoisted_22 = {
    class: "fs-20 text-00365b fw-bold mb-0 text-center",
    style: {
        "margin-top": "-6px"
    }
};
const $1c443093cf604a79$var$_hoisted_23 = {
    class: "fs-14 text-66869d lh-28 d-inline-block w-320",
    style: {
        "white-space": "pre-wrap"
    }
};
function $1c443093cf604a79$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ecd4d.openBlock)(), (0, $ecd4d.createElementBlock)("div", null, [
        (0, $ecd4d.createElementVNode)("header", $1c443093cf604a79$var$_hoisted_1, [
            (0, $ecd4d.createElementVNode)("nav", $1c443093cf604a79$var$_hoisted_2, [
                (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_3, [
                    _cache[4] || (_cache[4] = (0, $ecd4d.createElementVNode)("a", {
                        class: "navbar-brand mt-2 mt-lg-0",
                        href: "/",
                        style: {
                            "margin-left": "0.5rem"
                        }
                    }, [
                        (0, $ecd4d.createElementVNode)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3nVlx))),
                            width: "168",
                            height: "32",
                            alt: "SCANAT Logo",
                            loading: "lazy"
                        })
                    ], -1)),
                    (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_4, [
                        (0, $ecd4d.createVNode)($setup["LanguageSwitcher"]),
                        (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_5, [
                            _cache[3] || (_cache[3] = (0, $ecd4d.createElementVNode)("a", {
                                class: "dropdown-toggle d-flex align-items-center hidden-arrow gap-3",
                                href: "#",
                                id: "navbarDropdownMenuAvatar",
                                role: "button",
                                "data-mdb-toggle": "dropdown",
                                "data-mdb-display": "static"
                            }, [
                                (0, $ecd4d.createElementVNode)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($iaZWL))),
                                    class: "rounded-circle",
                                    height: "32",
                                    width: "32",
                                    alt: "Black and White Portrait of a Man",
                                    loading: "lazy"
                                }),
                                (0, $ecd4d.createElementVNode)("span", {
                                    style: {
                                        "font-weight": "500",
                                        "font-size": "0.875rem",
                                        "color": "#16191e"
                                    },
                                    class: "customer-name"
                                }, " - ")
                            ], -1)),
                            (0, $ecd4d.createElementVNode)("ul", $1c443093cf604a79$var$_hoisted_6, [
                                _cache[2] || (_cache[2] = (0, $ecd4d.createElementVNode)("li", {
                                    class: "d-flex gap-12",
                                    style: {
                                        "color": "#16191e",
                                        "padding-bottom": "0.75rem",
                                        "border-bottom": "1px solid #00365b14"
                                    }
                                }, [
                                    (0, $ecd4d.createElementVNode)("span", null, "ID"),
                                    (0, $ecd4d.createElementVNode)("span", {
                                        class: "customer-id",
                                        style: {
                                            "overflow-wrap": "break-word",
                                            "color": "#00426f"
                                        }
                                    }, "-")
                                ], -1)),
                                (0, $ecd4d.createElementVNode)("li", $1c443093cf604a79$var$_hoisted_7, [
                                    _cache[0] || (_cache[0] = (0, $ecd4d.createElementVNode)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6b4pF))),
                                        alt: "web",
                                        class: "icon-16"
                                    }, null, -1)),
                                    (0, $ecd4d.createElementVNode)("span", $1c443093cf604a79$var$_hoisted_8, (0, $ecd4d.toDisplayString)($setup.$t('landing.scanatWeb')), 1)
                                ]),
                                (0, $ecd4d.createElementVNode)("li", $1c443093cf604a79$var$_hoisted_9, [
                                    _cache[1] || (_cache[1] = (0, $ecd4d.createElementVNode)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fj6mT))),
                                        alt: "dashboard",
                                        class: "icon-16"
                                    }, null, -1)),
                                    (0, $ecd4d.createElementVNode)("span", $1c443093cf604a79$var$_hoisted_10, (0, $ecd4d.toDisplayString)($setup.$t('landing.idManage')), 1)
                                ]),
                                (0, $ecd4d.createElementVNode)("li", $1c443093cf604a79$var$_hoisted_11, [
                                    (0, $ecd4d.createElementVNode)("button", $1c443093cf604a79$var$_hoisted_12, (0, $ecd4d.toDisplayString)($setup.$t('landing.logout')), 1)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        (0, $ecd4d.createElementVNode)("main", $1c443093cf604a79$var$_hoisted_13, [
            (0, $ecd4d.createElementVNode)("h1", $1c443093cf604a79$var$_hoisted_14, (0, $ecd4d.toDisplayString)($setup.$t('landing.select')), 1),
            (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_15, [
                (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_16, [
                    _cache[5] || (_cache[5] = (0, $ecd4d.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($iU45Q))),
                        alt: "business",
                        style: {
                            "width": "11.5rem",
                            "height": "11.5rem",
                            "margin": "0 auto"
                        }
                    }, null, -1)),
                    (0, $ecd4d.createElementVNode)("h2", $1c443093cf604a79$var$_hoisted_17, (0, $ecd4d.toDisplayString)($setup.$t('landing.idManage')), 1),
                    _cache[6] || (_cache[6] = (0, $ecd4d.createElementVNode)("span", {
                        class: "w-100",
                        style: {
                            "height": "0",
                            "border": "1px dashed #ccd7de"
                        }
                    }, null, -1)),
                    (0, $ecd4d.createElementVNode)("span", $1c443093cf604a79$var$_hoisted_18, (0, $ecd4d.toDisplayString)($setup.$t('landing.tipId')), 1)
                ]),
                (0, $ecd4d.createElementVNode)("div", $1c443093cf604a79$var$_hoisted_19, [
                    (0, $ecd4d.createElementVNode)("object", {
                        data: $setup.webSvgUrl,
                        type: "image/svg+xml",
                        style: {
                            "width": "11.5rem",
                            "height": "11.5rem",
                            "margin": "0 auto",
                            "pointer-events": "none"
                        }
                    }, [
                        (0, $ecd4d.createElementVNode)("img", {
                            src: $setup.webSvgUrl,
                            alt: "business",
                            style: {
                                "width": "11.5rem",
                                "height": "11.5rem",
                                "margin": "0 auto"
                            }
                        }, null, 8, $1c443093cf604a79$var$_hoisted_21)
                    ], 8, $1c443093cf604a79$var$_hoisted_20),
                    _cache[7] || (_cache[7] = (0, $ecd4d.createElementVNode)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($lJVOw))),
                        alt: "beta",
                        class: "position-absolute w-20 top-48",
                        style: {
                            "left": "8.625rem"
                        }
                    }, null, -1)),
                    (0, $ecd4d.createElementVNode)("h2", $1c443093cf604a79$var$_hoisted_22, (0, $ecd4d.toDisplayString)($setup.$t('landing.scanatWeb')), 1),
                    _cache[8] || (_cache[8] = (0, $ecd4d.createElementVNode)("span", {
                        class: "w-100",
                        style: {
                            "height": "0",
                            "border": "1px dashed #ccd7de"
                        }
                    }, null, -1)),
                    (0, $ecd4d.createElementVNode)("span", $1c443093cf604a79$var$_hoisted_23, (0, $ecd4d.toDisplayString)($setup.$t('landing.tipScanat')), 1)
                ]),
                _cache[9] || (_cache[9] = (0, $ecd4d.createElementVNode)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($lAm4W))),
                    alt: "cube",
                    class: "position-absolute",
                    style: {
                        "left": "-18.625rem",
                        "top": "-8rem"
                    }
                }, null, -1)),
                _cache[10] || (_cache[10] = (0, $ecd4d.createElementVNode)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cB4N0))),
                    alt: "cube",
                    class: "position-absolute",
                    style: {
                        "left": "-11rem",
                        "bottom": "-4rem"
                    }
                }, null, -1)),
                _cache[11] || (_cache[11] = (0, $ecd4d.createElementVNode)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($991OD))),
                    alt: "cube",
                    class: "position-absolute",
                    style: {
                        "right": "-14rem",
                        "bottom": "-8rem"
                    }
                }, null, -1))
            ])
        ]),
        (0, $ecd4d.createVNode)($setup["ModalNoPermission"])
    ]);
}

});
parcelRegister("iaZWL", function(module, exports) {
module.exports = import.meta.resolve("ikjdy");

});

parcelRegister("6b4pF", function(module, exports) {
module.exports = import.meta.resolve("4JARC");

});

parcelRegister("fj6mT", function(module, exports) {
module.exports = import.meta.resolve("eq1x7");

});

parcelRegister("iU45Q", function(module, exports) {
module.exports = import.meta.resolve("fJ3mY");

});

parcelRegister("lJVOw", function(module, exports) {
module.exports = import.meta.resolve("1iJgR");

});

parcelRegister("lAm4W", function(module, exports) {
module.exports = import.meta.resolve("hFHzn");

});

parcelRegister("cB4N0", function(module, exports) {
module.exports = import.meta.resolve("kmG1I");

});

parcelRegister("991OD", function(module, exports) {
module.exports = import.meta.resolve("f5Ud9");

});


parcelRegister("5a9nT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c252a78dd053499$export$2e2bcd8739ae039);
let $3c252a78dd053499$var$NOOP = ()=>{};
var $3c252a78dd053499$export$2e2bcd8739ae039 = (script)=>{};

});


var $ecd4d = parcelRequire("ecd4d");

var $iS8eH = parcelRequire("iS8eH");
let $5084c70fac72995c$var$script;



let $5084c70fac72995c$var$initialize = ()=>{
    $5084c70fac72995c$var$script = (parcelRequire("ix7R1"));
    if ($5084c70fac72995c$var$script.__esModule) $5084c70fac72995c$var$script = $5084c70fac72995c$var$script.default;
    $5084c70fac72995c$var$script.render = (parcelRequire("2wdrK")).render;
    (parcelRequire("71t6w")).default($5084c70fac72995c$var$script);
    $5084c70fac72995c$var$script.__scopeId = 'data-v-2243eb';
    $5084c70fac72995c$var$script.__file = "Login.vue";
};
$5084c70fac72995c$var$initialize();
var $5084c70fac72995c$export$2e2bcd8739ae039 = $5084c70fac72995c$var$script;


let $8fd62f619f803fca$var$script;



let $8fd62f619f803fca$var$initialize = ()=>{
    $8fd62f619f803fca$var$script = (parcelRequire("aEG6O"));
    if ($8fd62f619f803fca$var$script.__esModule) $8fd62f619f803fca$var$script = $8fd62f619f803fca$var$script.default;
    $8fd62f619f803fca$var$script.render = (parcelRequire("766Bb")).render;
    (parcelRequire("fo24w")).default($8fd62f619f803fca$var$script);
    $8fd62f619f803fca$var$script.__scopeId = 'data-v-be016a';
    $8fd62f619f803fca$var$script.__file = "ResetPassword.vue";
};
$8fd62f619f803fca$var$initialize();
var $8fd62f619f803fca$export$2e2bcd8739ae039 = $8fd62f619f803fca$var$script;


let $405959e2374db032$var$script;



let $405959e2374db032$var$initialize = ()=>{
    $405959e2374db032$var$script = (parcelRequire("8F92D"));
    if ($405959e2374db032$var$script.__esModule) $405959e2374db032$var$script = $405959e2374db032$var$script.default;
    $405959e2374db032$var$script.render = (parcelRequire("2qsAR")).render;
    (parcelRequire("5a9nT")).default($405959e2374db032$var$script);
    $405959e2374db032$var$script.__scopeId = 'data-v-f3d5bb';
    $405959e2374db032$var$script.__file = "Landing.vue";
};
$405959e2374db032$var$initialize();
var $405959e2374db032$export$2e2bcd8739ae039 = $405959e2374db032$var$script;


const $8cae69ebec42c1bb$var$mountApp = (selector, RootComponent)=>{
    const el = document.querySelector(selector);
    if (!el) return;
    const app = (0, $ecd4d.createApp)(RootComponent);
    app.use((0, $iS8eH.default));
    app.mount(selector);
};
$8cae69ebec42c1bb$var$mountApp('#login-app', (0, $5084c70fac72995c$export$2e2bcd8739ae039));
$8cae69ebec42c1bb$var$mountApp('#reset-app', (0, $8fd62f619f803fca$export$2e2bcd8739ae039));
$8cae69ebec42c1bb$var$mountApp('#landing-app', (0, $405959e2374db032$export$2e2bcd8739ae039));


//# sourceMappingURL=login.6d045b9a.js.map
